import moment from 'moment'
//数据更新,不需要使用props传，方便使用
//全部清除
export const RemoveAll = () => {
    MethodsActive = null
    MethodCodeActive = null
    MethodsDetails = null
    DepositMoneyStatus = null
    DepositBankActive = null
    DepositMemberBanksActive = null
    DepositPayments = null
    DepositOldBankSixNumberStatus = null
    DepositCardNumber_CC = null
    DepositCardPIN_CC = null
    DepositDateSelect = null
    DepositTimeSelect = null
    UploadFileList = null
    UploadMenber = null
    LBOfflineRefNo = null
}



//选中存款方式
let MethodsActive = null
export const UpdateMethodsActive = (data = {}) => {
    MethodsActive = data
}
export const GetMethodsActive = () => {
    return MethodsActive || {}
}

//选中渠道MethodCode
let MethodCodeActive = null
export const UpdateMethodCodeActive = (data = '') => {
    MethodCodeActive = data
}
export const GetMethodCodeActive = () => {
    return MethodCodeActive || 'DEFAULT'
}

//选中存款详情
let MethodsDetails = null
export const UpdateMethodsDetails = (data = {}) => {
    MethodsDetails = data
}
export const GetMethodsDetails = () => {
    return MethodsDetails || {}
}

//存款金额
let DepositMoneyStatus = null
export const UpdateDepositMoneyStatus = (data = {}) => {
    DepositMoneyStatus = data
}
export const GetDepositMoneyStatus = () => {
    return DepositMoneyStatus || {}
}

//LB refNo
let LBOfflineRefNo = null
export const UpdateLBOfflineRefNo = (data = {}) => {
    LBOfflineRefNo = data
}
export const GetLBOfflineRefNo = () => {
    return LBOfflineRefNo || {}
}

//选中存款银行
let DepositBankActive = null
export const UpdateDepositBankActive = (data = {}) => {
    DepositBankActive = data
}
export const GetDepositBankActive = () => {
    return DepositBankActive || {}
}

//选中用户银行
let DepositMemberBanksActive = null
export const UpdateDepositMemberBanksActive = (data = {}) => {
    DepositMemberBanksActive = data
}
export const GetDepositMemberBanksActive = () => {
    return DepositMemberBanksActive || {}
}

//提款成功后的api数据
let DepositPayments = null
export const UpdateDepositPayments = (data = {}) => {
    DepositPayments = data
}
export const GetDepositPayments = () => {
    return DepositPayments || {}
}

//旧银行后6位数
let DepositOldBankSixNumberStatus = null
export const UpdateDepositOldBankSixNumberStatus = (data = {}) => {
    DepositOldBankSixNumberStatus = data
}
export const GetDepositOldBankSixNumberStatus = () => {
    return DepositOldBankSixNumberStatus || {}
}
//CC卡号码
let DepositCardNumber_CC = null
export const UpdateDepositCardNumber_CC = (data = {}) => {
    DepositCardNumber_CC = data
}
export const GetDepositCardNumber_CC = () => {
    return DepositCardNumber_CC || {}
}
//CC卡密码
let DepositCardPIN_CC = null
export const UpdateDepositCardPIN_CC = (data = {}) => {
    DepositCardPIN_CC = data
}
export const GetDepositCardPIN_CC = () => {
    return DepositCardPIN_CC || {}
}
//日期选择
let DepositDateSelect = null
export const UpdateDepositDateSelect = (data = '') => {
    DepositDateSelect = data
}
export const GetDepositDateSelect = () => {
    return DepositDateSelect || moment(new Date()).format('YYYY-MM-DD')
    // return DepositDateSelect || ''
}

//时间选择
let DepositTimeSelect = null
export const UpdateDepositTimeSelect = (data = '') => {
    DepositTimeSelect = data
}
export const GetDepositTimeSelect = () => {
    return DepositTimeSelect || moment(new Date()).format('HH:mm')
    //return DepositTimeSelect || ''
}
//图片信息
let UploadFileList = null
export const UpdateUploadFileList = (data = '') => {
    UploadFileList = data
}
export const GetUploadFileList = () => {
    return UploadFileList || []
}

//menber
let UploadMenber = null
export const UpdateMenber = (data = '') => {
    UploadMenber = data
}
export const GetMenber = () => {
    return UploadMenber || {}
}


//menber
let DepositAccountByAmount = null
export const UpdateDepositAccountByAmountValues = (data = null) => {
    DepositAccountByAmount = data
}
export const GetDepositAccountByAmountValues = () => {
    return DepositAccountByAmount || {}
}





